(function ($) {


  if ($('.section--discover-other .stories__load-more').length) {

    let _lang = $('.story-language').val();
    let _path = drupalSettings.path.baseUrl;
    let btn = $('.section--discover-other .stories__load-more');
    let _wrapper = $('.section--discover-other .links-wrapper');

    let data = {
      totalCount: parseInt(btn.attr('data-total')),
      offset: parseInt(btn.attr('data-offset')),
      notInclude: parseInt(btn.attr('data-self')),
      currentLang: _lang,
      endpoint: (_lang != 'en') ? _path + _lang + '/ajax/get-stories' : _path + 'ajax/get-stories'
    };

    $('.section--discover-other .stories__load-more').on('click', function () {
      console.log(data);
      $.ajax({
        type: 'POST',
        url: data.endpoint,
        data: data
      }).done(function (results) {
        _wrapper.append(results.html).ready(function () {
          data.offset = results.itemsLoaded;
          if (data.offset >= data.totalCount) {
            btn.hide();
          }
        });
      });
    });
  }


})(jQuery);



